
import { Component, Vue, Prop } from 'vue-property-decorator';

interface MenuItem {
  id: string;
  to: string;
  label: string;
}

@Component
export default class MyAccountMenu extends Vue {
  @Prop({ type: Array, required: true }) menuItems!: MenuItem[];
  @Prop({ type: String, default: 'myAccountMenu' }) menuId!: string;
  @Prop({ type: String, default: 'myAccountButton' }) buttonId!: string;

  isOpen = false;
  activeDescendantId: string | null = null;
  firstChars: string[] = [];

  mounted() {
    this.initializeMenu();
    window.addEventListener('mousedown', this.onBackgroundMousedown, true);
  }

  destroyed() {
    window.removeEventListener('mousedown', this.onBackgroundMousedown, true);
  }

  initializeMenu() {
    this.firstChars = this.menuItems.map(item => item.label.trim()[0].toLowerCase());
  }

  setFocusToMenuitem(item: MenuItem) {
    this.activeDescendantId = item.id;
  }

  setFocusToFirstMenuitem() {
    if (this.menuItems.length > 0) {
      this.setFocusToMenuitem(this.menuItems[0]);
    }
  }

  setFocusToLastMenuitem() {
    if (this.menuItems.length > 0) {
      this.setFocusToMenuitem(this.menuItems[this.menuItems.length - 1]);
    }
  }

  setFocusToPreviousMenuitem() {
    if (!this.activeDescendantId) return;
    const currentIndex = this.menuItems.findIndex(item => item.id === this.activeDescendantId);
    if (currentIndex === 0) {
      this.setFocusToLastMenuitem();
    } else {
      this.setFocusToMenuitem(this.menuItems[currentIndex - 1]);
    }
  }

  setFocusToNextMenuitem() {
    if (!this.activeDescendantId) return;
    const currentIndex = this.menuItems.findIndex(item => item.id === this.activeDescendantId);
    if (currentIndex === this.menuItems.length - 1) {
      this.setFocusToFirstMenuitem();
    } else {
      this.setFocusToMenuitem(this.menuItems[currentIndex + 1]);
    }
  }

  setFocusByFirstCharacter(char: string) {
    if (char.length !== 1) return;
    char = char.toLowerCase();
    let start = 0;
    if (this.activeDescendantId) {
      const currentIndex = this.menuItems.findIndex(item => item.id === this.activeDescendantId);
      start = currentIndex + 1;
      if (start >= this.menuItems.length) start = 0;
    }
    let index = this.firstChars.indexOf(char, start);
    if (index === -1) {
      index = this.firstChars.indexOf(char, 0);
    }
    if (index > -1) {
      this.setFocusToMenuitem(this.menuItems[index]);
    }
  }

  openPopup() {
    this.isOpen = true;
    this.$nextTick(() => {
      (this.$refs.menuNode as HTMLElement).focus();
      this.setFocusToFirstMenuitem();
    });
  }

  closePopup() {
    this.isOpen = false;
    this.activeDescendantId = null;
    (this.$refs.buttonNode as any).$el.focus();
  }

  onButtonKeydown(event: KeyboardEvent) {
    let stopFlag = false;
    switch (event.key) {
      case ' ':
      case 'Enter':
      case 'ArrowDown':
        this.openPopup();
        stopFlag = true;
        break;
      case 'ArrowUp':
        this.openPopup();
        this.setFocusToLastMenuitem();
        stopFlag = true;
        break;
      case 'Escape':
        this.closePopup();
        stopFlag = true;
        break;
    }
    if (stopFlag) {
      event.stopPropagation();
      event.preventDefault();
    }
  }

  onButtonClick(event: Event) {
    if (this.isOpen) {
      this.closePopup();
    } else {
      this.openPopup();
    }
    event.stopPropagation();
    event.preventDefault();
  }

  onMenuKeydown(event: KeyboardEvent) {
    if (event.ctrlKey || event.altKey || event.metaKey) return;
    let stopFlag = false;
    const isPrintableCharacter = (str: string) => str.length === 1 && str.match(/\S/);
    console.log("onMenuKeydown", event.key)
    if (event.shiftKey) {
      if (isPrintableCharacter(event.key)) {
        this.setFocusByFirstCharacter(event.key);
        stopFlag = true;
      }
      if (event.key === 'Tab') {
        this.closePopup();
        stopFlag = true;
      }
    } else {
      switch (event.key) {
        case 'Enter':
          const item = this.menuItems.find(i => i.id === this.activeDescendantId);
          this.closePopup();
          this.performMenuAction(item);
          stopFlag = true;
          break;
        case 'Escape':
          this.closePopup();
          stopFlag = true;
          break;
        case 'ArrowUp':
          this.setFocusToPreviousMenuitem();
          stopFlag = true;
          break;
        case 'ArrowDown':
          this.setFocusToNextMenuitem();
          stopFlag = true;
          break;
        case 'Home':
          this.setFocusToFirstMenuitem();
          stopFlag = true;
          break;
        case 'End':
          this.setFocusToLastMenuitem();
          stopFlag = true;
          break;
        case 'Tab':
          this.closePopup();
          break;
        default:
          if (isPrintableCharacter(event.key)) {
            this.setFocusByFirstCharacter(event.key);
            stopFlag = true;
          }
      }
    }
    if (stopFlag) {
      event.stopPropagation();
      event.preventDefault();
    }
  }

  onMenuitemMouseover(item: MenuItem) {
    // this.setFocusToMenuitem(item);
  }

  onMenuitemClick(item: MenuItem) {
    this.closePopup();
    this.performMenuAction(item);
  }

  onBackgroundMousedown(event: MouseEvent) {
    const wrapper = this.$el;
    if (!wrapper.contains(event.target as Node)) {
      if (this.isOpen) {
        this.closePopup();
      }
    }
  }

  performMenuAction(item?: MenuItem) {
    const activeItem = item || this.menuItems.find(i => i.id === this.activeDescendantId);
    console.log("performMenuAction", activeItem)
    if (activeItem) {
      this.$router.push(activeItem.to);
    }
  }
}
